import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Vendordersdetails = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(''); // Date picker state
    const { showLoader, hideLoader } = useLoader();
    // Fetch orders
    useEffect(() => {
        const controller = new AbortController();

        const fetchOrders = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const headers = token ? { Authorization: `Bearer ${token}` } : {};
                const res = await fetch(
                    "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/orders/all",
                    { method: "GET", headers, signal: controller.signal }
                );
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const fetchedApiData = await res.json();
                setData(Array.isArray(fetchedApiData) ? fetchedApiData : []);
            } catch (err) {
                if (err.name !== "AbortError") console.error(err);
            } finally {
                hideLoader();
            }
        };

        fetchOrders();
        return () => controller.abort();
    }, []);

    // Filter by date
    useEffect(() => {
        if (!selectedDate) {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => {
                if (!item.cateringDate) return false;
                const itemDate = new Date(item.cateringDate);
                const selDate = new Date(selectedDate);
                return (
                    itemDate.getFullYear() === selDate.getFullYear() &&
                    itemDate.getMonth() === selDate.getMonth() &&
                    itemDate.getDate() === selDate.getDate()
                );
            });
            setFilteredData(filtered);
        }
    }, [selectedDate, data]);

    // Export CSV
    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("No data to export for the selected date.");
            return;
        }

        const headers = ["OrderID", "VendorID", "Location", "Date", "Time", "Package Type", "Package Name", "Payment", "Status", "Amount"];
        const rows = filteredData.map(item => [
            item.orderId || '-',
            item.vendorId || '-',
            item.location || '-',
            item.cateringDate ? new Date(item.cateringDate).toLocaleDateString("en-GB") : '-',
            item.cateringDate ? new Date(item.cateringDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-',
            item.orderItems ? item.orderItems.map(i => i.packageType).join(", ") : '-',
            item.orderItems ? item.orderItems.map(i => i.packageName).join(", ") : '-',
            item.paymentMethod || '-',
            item.paymentStatus || '-',
            item.total !== undefined ? Math.round(item.total) : '-'
        ]);

        const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const tabContent = {
        Overview: (
            <div>
                {/* Date Picker & Export Button */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "15px",
                        marginTop: "35px",
                    }}
                >
                    <div>

                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            style={filterSelectStyle}
                        />
                    </div>

                    <button
                        onClick={handleExport}
                        style={{
                            backgroundColor: "#b15cd6",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "bold",
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#a44ac0")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#b15cd6")}
                    >
                        Export
                    </button>
                </div>

                {/* Table */}
                <div className="table-responsive rr pe-2" style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    overflowX: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    scrollbarWidth: "thin"
                }}>
                    <table className="table-striped table-bordered align-middle" style={{ fontSize: "0.95rem", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>OrderID</th>
                                <th style={tableHeaderStyle}>VendorID</th>
                                <th style={tableHeaderStyle}>Location</th>
                                <th style={tableHeaderStyle}>Date</th>
                                <th style={tableHeaderStyle}>Time</th>
                                <th style={tableHeaderStyle}>Package Type</th>
                                <th style={tableHeaderStyle}>Package Name</th>
                                <th style={tableHeaderStyle}>Payment</th>
                                <th style={tableHeaderStyle}>Status</th>
                                <th style={tableHeaderStyle}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length ? (
                                filteredData.map((item, index) => (
                                    <tr key={item.orderId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                        <td style={tableCellStyle}>{item.orderId || "-"}</td>
                                        <td style={tableCellStyle}>#{item.vendorId || "-"}</td>
                                        <td style={tableCellStyle}>{item.location || "-"}</td>
                                        <td style={tableCellStyle}>{item.cateringDate ? new Date(item.cateringDate).toLocaleDateString("en-GB") : "-"}</td>
                                        <td style={tableCellStyle}>{item.cateringDate ? new Date(item.cateringDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "-"}</td>
                                        <td style={tableCellStyle}>{item.orderItems ? item.orderItems.map(i => i.packageType).join(", ") : "-"}</td>
                                        <td style={tableCellStyle}>{item.orderItems ? item.orderItems.map(i => i.packageName).join(", ") : "-"}</td>
                                        <td style={tableCellStyle}>{item.paymentMethod || "-"}</td>
                                        <td style={tableCellStyle}>{item.paymentStatus || "-"}</td>
                                        <td style={tableCellStyle}>{item.total !== undefined ? Math.round(item.total) : "-"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" style={{ ...tableCellStyle, fontStyle: "italic" }}>No data matches your filters.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    };

    return (
        <div>
            <div className="row" style={{ marginTop: '40px' }}>
                <div className="col-12">
                    <div style={{ overflowY: 'auto', height: 'calc(85vh - 40px)', marginTop: '-60px', scrollbarWidth: 'none' }}>
                        <div style={{ marginTop: '20px', borderRadius: '8px' }}>
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: 6,
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: 6,
};
const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};
export default Vendordersdetails;
